import React from "react";
import { Card, CardBody, CardTitle, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import { getUpcomingEvents } from "helpers/fakebackend_helper";
import { useQuery } from "react-query";

const ActivityComp = () => {

  const { data, isLoading } = useQuery('upcoming_events', getUpcomingEvents, {
    staleTime: 120000,
    refetchOnWindowFocus: false,
  });


  //data has format
  //   "upcoming_events": [
  //     {
  //         "id": 43,
  //         "name": "going to shoping",
  //         "description": "going to shoping",
  //         "start_at": "2024-10-11 07:01:54",
  //         "category": "General",
  //         "end_at": "2024-10-12 13:02:00",
  //         "created_by": {
  //             "id": 5,
  //             "name": "Ahsan Abir"
  //         },
  //         "parenting_space_id": 2,
  //         "created_at": "2024-10-09T07:02:12.000000Z",
  //         "updated_at": "2024-10-09T07:02:12.000000Z"
  //     }
  // ]

  return (
    <React.Fragment>
      <Card>
        <CardBody>

          <CardTitle className="mb-5">Activity</CardTitle>
          {isLoading ? <div className="text-center"><Spinner /></div> : (
            <>
              {data.upcoming_events.length === 0 ? (
                <div className="text-center">
                  <p>Schedule a calendar event</p>
                  <Link to="/calendar" className="btn btn-primary btn-sm" style={{ backgroundColor: "#2F8C47" }}>
                    Create Event <i className="mdi mdi-calendar-plus ms-1" />
                  </Link>
                </div>
              ) : (
                <ul className="verti-timeline list-unstyled">
                  {data.upcoming_events.map((event, index) => (
                    <li className="event-list" key={index}>
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle font-size-18" />
                      </div>
                      <div className="d-flex">
                        <div className="me-3">
                          <h5 className="font-size-12">
                            {new Date(event.start_at).toLocaleDateString('en-US', { month: 'long', day: 'numeric' })}
                            <br />
                            {new Date(event.start_at).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
                            {/* <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" /> */}
                          </h5>
                        </div>
                        <div className="flex-grow-1">
                          <div id="activitytext" style={{ fontSize: '14px' }}>
                            {event.name}
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
              <div className="text-center mt-4">
                <Link
                  to="/calendar"
                  className="btn btn-primary  btn-sm"
                  style={{ backgroundColor: "#2F8C47" }}
                >
                  View More <i className="mdi mdi-arrow-right ms-1" />
                </Link>
              </div>
            </>
          )}
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default ActivityComp;